import { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ContactFormValues } from "../../Types/types";
import FormikField from "../Common/FormikField";
import icon1 from "../../assets/images/location.svg";
import icon3 from "../../assets/images/mail.svg";
import { motion } from "motion/react";
import Blog from "../HomePage/Blog";
import img from "../../assets/images/contact-bg.webp";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const initialValues: ContactFormValues = {
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  };

  const validationSchema = Yup.object({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    message: Yup.string().required("Please enter the message"),
  });

  const handleSubmit = async (
    values: ContactFormValues,
    { resetForm }: { resetForm: () => void }
  ) => {
    setLoading(true);
    emailjs
      .send("service_4ey56b8", "template_cp9yn1f", values, "Bhsl-lUgs2ZfzWuPP")
      .then(
        () => {
          console.log("SUCCESS!");
          setPopupVisible(true);
          resetForm();
          setLoading(false);
          setTimeout(() => {
            setPopupVisible(false);
          }, 5000);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setLoading(false);
        }
      );
  };

  const closePopup = () => {
    setPopupVisible(false); 
  };

  useEffect(() => {
      const metaTag = document.querySelector("meta[name='description']");
      document.title = "Contact John Bostjancic | Get in Touch Today";
  
      if (metaTag) {
        document.head.appendChild(metaTag);
        metaTag.setAttribute(
          "content",
          "Contact John Bostjancic, an experienced CFO with 30+ years in finance, for business inquiries, consultations, or professional connections."
        );
      }
  
      let linkTag = document.querySelector("link[rel='canonical']");
      if (linkTag) {
        linkTag.setAttribute("href", "https://johnbostjancic.co/contact");
      } else {
        linkTag = document.createElement("link");
        (linkTag as HTMLLinkElement).rel = "canonical";
        (linkTag as HTMLLinkElement).href = "https://johnbostjancic.co/contact";
      }
  
      if (!document.head.contains(linkTag)) {
        document.head.appendChild(linkTag);
      }
  
      //keyWords
      let keyWordTag = document.querySelector("meta[name='keywords']");
      if (!keyWordTag) {
        keyWordTag = document.createElement("meta");
        (keyWordTag as HTMLMetaElement).name = "keywords";
        document.head.appendChild(keyWordTag);
      }
    keyWordTag.setAttribute("content", "Contact John Bostjancic");
    
    }, []);

  return (
    <>
      <div className="px-2 lg:px-10 xl:px-20 relative max-w-screen-2xl mx-auto overflow-hidden xl:overflow-visible">
        <div className="bg-[#E7E9FF]  xl:w-[57%] px-5 lg:px-11 py-8 sm:py-16 lg:pb-40  rounded-[36px] mb-5 xl:mb-0">
          <div className="relative mb-9 ml-5 lg:ml-0">
            <motion.h3
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="poppins-regular text-primary z-20 relative"
            >
              OUR CAPABILITIES
            </motion.h3>
            <div className="size-16 bg-[#ffff] rounded-full absolute -top-5 -left-5"></div>
          </div>
          <motion.h1
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="text-4xl lg:text-6xl montserrat-semibold text-secondary"
          >
            Reach Out To
          </motion.h1>
          <motion.h1
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 }}
            viewport={{ once: true }}
            className="text-4xl lg:text-6xl montserrat-semibold text-primary mb-6"
          >
            John Bostjancic
          </motion.h1>
          <motion.p
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 1.5 }}
            viewport={{ once: true }}
            className="text-secondary montserrat-medium lg:text-xl mb-6"
          >
            Get in touch with John Bostjancic, an experienced CFO, for
            consultation or inquiries. Reach out today to discuss how his
            strategic insights can drive your business forward.
          </motion.p>

          <div className="flex flex-col lg:flex-row gap-5 lg:gap-0 justify-between">
            <div className="flex  gap-4">
              <div className="py-3 px-4 bg-primary rounded-xl self-start">
                <img src={icon1} alt="" className="size-8" />
              </div>
              <div className="">
                <motion.p
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 2 }}
                  viewport={{ once: true }}
                  className="montserrat-semibold text-secondary"
                >
                  Address
                </motion.p>
                <motion.p
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 2.5 }}
                  viewport={{ once: true }}
                  className="montserrat-regular text-secondary"
                >
                  California, United State
                </motion.p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="py-3 px-4 bg-primary rounded-xl self-start">
                <img src={icon3} alt="" className="size-8" />
              </div>
              <div className="">
                <motion.p
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 2 }}
                  viewport={{ once: true }}
                  className="montserrat-semibold text-secondary"
                >
                  Help & Supoort
                </motion.p>
                <motion.p
                  initial={{ x: -100, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 2.5 }}
                  viewport={{ once: true }}
                  className="montserrat-regular text-secondary"
                >
                  Hello@johnbostjancic.com
                </motion.p>
              </div>
            </div>
          </div>
        </div>
        <div className="xl:absolute xl:w-[37%] -top-[110px] right-20 h-full">
          <div className="relative w-full">
            <img src={img} className="h-[680px] w-full hidden xl:block" alt=""/>
            {/* <svg
              // width="493"
              height="680"
             
              viewBox="0 0 493 732"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[350px] xl:w-full hidden xl:block"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M460 731C478.225 731 493 716.225 493 698V33C493 14.7746 478.225 0 460 0H256.126C243.771 0 231.806 5.57355 226.174 16.5709C216.864 34.7502 210.749 56.7824 204.877 77.939C202.288 87.2644 199.747 96.4197 197.001 105H44C19.6995 105 0 124.699 0 149V688C0 712.3 19.6994 732 44 732H340.96C344.175 732 347.311 731.655 350.33 731H460Z"
                fill="url(#paint0_linear_97_809)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_97_809"
                  x1="246.5"
                  y1="0.5"
                  x2="246.5"
                  y2="693.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.143" stop-color="#582EFF" />
                  <stop offset="1" stop-color="#E7E9FF" />
                </linearGradient>
              </defs>
            </svg> */}
            <div className=" xl:hidden h-[650px] bg-gradient-to-b from-primary to-white rounded-[50px]"></div>
            <div className="size-[400px] bg-white p-14 rounded-full absolute top-40 left-16 bg-opacity-5">
              <div className="size-full bg-white p-14 rounded-full bg-opacity-5">
                <div className="size-full bg-white rounded-full bg-opacity-5"></div>
              </div>
            </div>
            <button className="hidden xl:block bg-[#E9FF7A] hover:bg-secondary hover:text-white py-3 px-7 absolute top-12 xl:top-10 right-0 xl:right-20 2xl:right-24 montserrat-medium rounded-full text-xl z-30 transition-all duration-300">
              Contact Me
            </button>
            <div className="absolute top-10 xl:top-[150px] lg:w-[90%] xl:w-[80%] left-8 lg:left-[50px] z-20 bg-white rounded-3xl overflow-hidden">
              <div className=" px-10 pt-10 pb-16">
                <h2 className="text-secondary text-xl montserrat-semibold mb-6">
                  Send Us A Message
                </h2>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {() => (
                    <Form className="space-y-3">
                      <div className="flex gap-4 flex-col sm:flex-row">
                        <FormikField
                          name="firstName"
                          placeholder="First Name"
                        />
                        <FormikField name="lastName" placeholder="Last Name" />
                      </div>
                      <div>
                        <FormikField name="email" placeholder="Email" />
                      </div>
                      <div>
                        <FormikField
                          name="message"
                          as="textarea"
                          rows={4}
                          placeholder="Your Message"
                        />
                      </div>
                      <div className="flex justify-start">
                        <button
                          type="submit"
                          className="px-4 py-2 montserrat-medium text-white rounded-full bg-secondary hover:bg-primary"
                        >
                          Contact Us
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="px-4 py-4 sm:px-6 lg:px-20 sm:py-28 relative z-20 bg-white">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3464.2263025457837!2d-95.42471662424101!3d29.742163075077247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c0e92e0628c9%3A0xcffbb134c76ad5bf!2skreative%20Solutions!5e0!3m2!1sen!2sin!4v1732852337174!5m2!1sen!2sin"
          width="100%"
          height="450"
          allowFullScreen={true}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div> */}
      <Blog />
          {loading && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-6 rounded shadow-lg text-center">
                <h3 className="text-lg font-semibold">Sending...</h3>
                <p className="mt-2">Please wait while we send your message.</p>
              </div>
            </div>
          )}

          {popupVisible && (
            <div className="fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white relative p-6 rounded flex flex-col shadow-lg text-center justify-center items-center h-[50%] md:h-[50%] w-[70%] md:w-auto">
                <div className="p-5 bg-primary rounded-full mb-10 absolute top-[-12%]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    height="80px"
                    width="80px"
                    fill="white"
                  >
                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl md:text-4xl my-4 font-body font-semibold mx-10">
                  Email Sent Successfully!
                </h3>
                <p className="my-4 md:text-lg font-poppins">
                  Thank you for getting in touch.
                </p>
                <button
                  className="mt-4 py-4 px-10 md:text-xl text-white font-body font-bold bg-primary rounded-full"
                  onClick={closePopup}
                >
                  Close
                </button>
              </div>
            </div>
          )}
    </>
  );
};

export default Contact;
